import { render, staticRenderFns } from "./MotionTriggers.vue?vue&type=template&id=163de3c3"
import script from "./MotionTriggers.vue?vue&type=script&lang=js"
export * from "./MotionTriggers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports